<template>
    <div class="tool-wrapper">
        <div v-if="banner && banner.length" class="tool-wrapper-banner">
            <img :src="img.logo" v-for="img in banner" :key="img.logo" alt="" @click="openBanner(img.url)">
        </div>
        <div class="tool-wrapper-body">
            <div class="tool">
                <!-- 导航栏 -->
                <div class="tool-tabs">
                    <Tabs :tabsList="tabsList" :activeType="activeType" @handleTab="handleTab" />
                </div>
                <tool-list v-if="tabsList.length > 0" :type="activeType" :styleType="styleType"></tool-list>
            </div>
            <!-- 侧边栏 -->
            <div class="aside" :style="{'minHeight': asideHeight+'px'}">
                <aside-card class="aside-item" ref="asideItem" circle-color="purple"></aside-card>
                <aside-banner class="aside-item" ref="asideBanner"></aside-banner>
            </div>
        </div>
    </div>
</template>

<script>
import { getToolTabs } from '@/api/tool';
import { getBannerURL } from '@/api/common';
import ToolList from './components/ToolList';
import AsideCard from '@/views/components/AsideCard';
import AsideBanner from '@/views/components/AsideBanner';
import Tabs from '@/components/Tabs';

export default {
    name: 'Tool',
    components: {
        AsideCard,
        AsideBanner,
        ToolList,
        Tabs
    },
    data: () => ({
        activeType: sessionStorage.getItem('toolTab') || null,
        styleType: null,
        tabsList: [],
        asideHeight: 0,
        banner: null,
    }),
    mounted() {
        this.getTabs();
        this.getBannerURL();
        setTimeout(this.getAsideHeight,2000)
    },
    methods: {
        openBanner(imgUrl) {
            window.open(imgUrl);
        },
        // 获取banner图地址
        getBannerURL() {
            getBannerURL(4).then(({ data }) => {
                this.banner = (data || []).splice(0,2);
            });
        },
        getTabs() {
            getToolTabs().then(({ code, data }) => {
                if (code === 0) {
                    const tabsList = data.map(({ type, typename, styletype }) => {
                        return {
                            type,
                            styletype,
                            title: typename
                        };
                    });
                    this.tabsList = [
                        ...tabsList
                    ];
                    this.activeType = this.activeType || this.tabsList[0].type;
                    this.styleType = this.tabsList[0].styletype;
                }
            });
        },
        handleTab(type, tab) {
            sessionStorage.setItem('toolTab', type)
            sessionStorage.setItem(this.$route.path, 1)
            this.styleType = tab.styletype;
            this.activeType = type;
        },
        getAsideHeight() {
            this.asideHeight = this.$refs.asideItem.$el.clientHeight + this.$refs.asideBanner.$el.clientHeight
            console.log('this.asideHeight: ', this.asideHeight);
        }
    }
};
</script>

<style lang="scss" scoped>
.tool-wrapper {
    padding-bottom: 20px;
    .tool {
        width: 1280px;

        &-tabs {
            padding-bottom: 10px;
            border-bottom: 1px solid rgba(224, 228, 247, 1);
        }
    }
    &-banner {
        // padding: 20px 0;
        // background-color: #fff;
        text-align: center;
        font-size: 0;
		display: flex;
		padding: 20px 0 0 0;
		width: 1600px;
		overflow: hidden;
		margin: 0 auto;
        > img {
            cursor: pointer;
            flex:1;
			margin-right: 20px;
			border-radius: 4px;
			height: 120px;
            font-size: 0;
			width: 790px;
			&:nth-last-child(1) {
				margin-right: 0;
			}
        }
    }
    &-body {
        margin: 0 auto;
        padding-top: 20px;
        width: 1600px;
        display: flex;
    }

    .aside {
        width: 300px;
        margin-left: 20px;
        position: relative;

        &-item:not(:first-child) {
            margin-top: 20px;
        }
    }
}

// 小屏
@include mq($small) {
    .tool-wrapper {
        .tool {
            width: 945px;

            &-tabs {
                padding-bottom: 4px;
            }
        }

        .aside {
            width: 225px;
            margin-left: 18px;
        }
    }
}
</style>
